import React from 'react';
import { Button, Form, Input, message, Modal, Radio, Spin } from 'antd';
import { handleExportParams } from '../../../utils';
import { isPhone } from "../../../utils/validate";
import { fetchTransferRecordLogFlowApproval, fetchTransferRecordLogFlowNeedSms, fetchTransferRecordLogSendSmsCode } from '../../../services/transferRecordLog';
/**
 * 分账记录 - 流程审批
 */
class TransferRecordFlowApprovalModal extends React.Component{
    constructor() {
        super();
        this.state = {
            visible: false,
            loading: false,
            formData: {},
            codeTime: 0,
            needSms: false,
        };
    }

  
    open = (transferRecordLogId) => {
        this.transferRecordLogId = transferRecordLogId
        this.setState({ visible: true });
        this.postFlowNeedSms()
        return new Promise((resolve, reject) => {
            this.monitor = { resolve, reject }
        })
    };

    close = () => {
        this.setState({ visible: false, formData: {} });
    };
    getLoginPhone() {
        return handleExportParams().phone
    }

    checkFormData = (data) => {
        if (!data.verifyCode && this.state.needSms) return message.warn('请输入验证码')
        if (!data.pwd) return message.warn('请输入登录密码')
        if (!data.status) return message.warn('请选择状态')
        if (data.status === 2 && !data.remarks) return message.warn('请输入备注')
        return true
    }

    handleChange = (e,key) => {
        const { value } = e.target
        this.setState(state => {
            state.formData[key] = value
            return state
        })
    }
    setCodeTimeout() {
        if (this.state.codeTime === 0) {
            this.setState({ codeTime : 60 })
            setTimeout(() =>this.setCodeTimeout(),1000)
        } else {
            this.setState({ codeTime : this.state.codeTime -1 }, () => {
                this.state.codeTime > 0 && setTimeout(() =>this.setCodeTimeout(),1000)
            })
        }
    }

    handleCodeGet = () => {
        const phone = this.getLoginPhone()
        if (!phone) return message.warn('请输入手机号')
        if (!isPhone(phone)) return message.warn('请输入正确的手机号')
        this.setCodeTimeout()

        this.postPhoneCodeGet()
    }

    handleOk = () => {
        if (this.checkFormData(this.state.formData) !== true) return
        this.postConfirmationProcess().then(() => {
            this.close()
            this.monitor.resolve()
        })
    }

    postPhoneCodeGet() {
        fetchTransferRecordLogSendSmsCode().then(() => {
            message.success('发送成功')
        })
    }
    postConfirmationProcess() {
        const data = {
            ...this.state.formData,
            transferRecordLogId: this.transferRecordLogId
        }
        if (!this.state.needSms) {
            data.verifyCode = ''
        }
        this.setState({ loading: true })
        return fetchTransferRecordLogFlowApproval(data).then(() => {
            message.success('操作成功')
        }).finally(()=>{
            this.setState({ loading: false })
        })
    }
    postFlowNeedSms() {
        const data = {transferRecordLogId: this.transferRecordLogId}
        fetchTransferRecordLogFlowNeedSms(data).then(res => {
            this.setState({ needSms: res })
        })
    }
    render(){
        const loading = !!this.state.loading
        const { codeTime, needSms } = this.state
        return (
           <Modal title="流程审批" visible={this.state.visible} onOk={this.handleOk} onCancel={this.close} confirmLoading={loading}>
               <Spin spinning={loading}>
                    <Form style={{padding: 20}} ref={ref => this.FormRef = ref}>
                        {needSms && (
                            <React.Fragment>
                                 <Form.Item required label="手机号" style={{marginBottom: 5}}>
                                    <Input disabled  value={this.getLoginPhone()} />
                                </Form.Item>
                                <Form.Item required label="验证码" style={{marginBottom: 5}}>
                                    <div style={{display: 'flex'}}>
                                        <Input onChange={(e) => this.handleChange(e, 'verifyCode')} value={this.state.formData.verifyCode} />
                                        <Button disabled={codeTime > 0} style={{marginLeft: 10}} onClick={this.handleCodeGet}>
                                            {codeTime === 0 ? '获取验证码' : (codeTime + 's')}
                                        </Button>
                                    </div>
                                </Form.Item>
                            </React.Fragment>
                        )}
                       
                        <Form.Item required label="登录密码" style={{marginBottom: 5}}>
                            <Input type="password" autoComplete={false}  onChange={(e) => this.handleChange(e, 'pwd')} value={this.state.formData.pwd} />
                        </Form.Item>
                        <Form.Item required label="审核" style={{marginBottom: 5}}>
                            <Radio.Group onChange={(e) => this.handleChange(e, 'status')} value={this.state.formData.status}>
                                <Radio value={1}>通过</Radio>
                                <Radio value={2}>不通过</Radio>
                            </Radio.Group>
                        </Form.Item>
                        { this.state.formData.status === 2 && (
                            <Form.Item required label="备注">
                                <Input.TextArea onChange={(e) => this.handleChange(e, 'remarks')} value={this.state.formData.remarks}  />
                            </Form.Item>
                        )}
                    </Form>
                </Spin>
           </Modal>
           
        )
    }

}

export default TransferRecordFlowApprovalModal


// WEBPACK FOOTER //
// ./src/page/TransferRecordLog/components/FlowApprovalModal.jsx